<template>
  <div class="view marketing recipients-edit">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3"><strong>Edit Recipient Group</strong></h3>
        <div class="mb-3" v-if="group">
          <a-tag color="blue" v-if="group.created_at">Created {{ group.created_at | moment('from') }}</a-tag>
          <a-tag color="green" v-if="group.updated_at">Updated {{ group.updated_at | moment('from') }}</a-tag>
        </div>
      </div>
      <div class="content" v-if="group">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">{{ group.name || 'New Group' }}</h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <span>
                <a-button type="primary" icon="save" @click="onUpdateGroup"> Save Group </a-button>
              </span>
            </div>
          </div>
          <div class="wrap p-3">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-light">
              You can create targeting recipients based on customers' information
            </div>
            <div class="form">
              <!-- basic -->
              <a-form-model layout="vertical" :model="group">
                <a-form-model-item label="Group Name">
                  <a-input v-model="group.name" placeholder="Group name..." />
                </a-form-model-item>

                <a-form-model-item label="Group Description">
                  <a-input v-model="group.description" placeholder="Group description..." />
                </a-form-model-item>

                <a-form-model-item label="Selector Mode">
                  <a-radio-group
                    v-model="group.selector_mode"
                    default-value="detailed_mode"
                    button-style="solid"
                    :size="size"
                  >
                    <a-radio-button value="detailed_mode"> Detailed Mode </a-radio-button>
                    <a-radio-button value="preset_mode"> Preset Mode </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-form-model>

              <!-- detailed selector -->
              <template v-if="group.selector_mode === 'detailed_mode'">
                <Filters @onFilter="onFilter"></Filters>
                <CustomerSelectorTable v-model="selectedKeys" @onSelectionChange="onSelectionChange" />
              </template>
              <!-- preset selector  -->
              <template v-if="group.selector_mode === 'preset_mode'">
                <div class="card p-3">
                  <a-checkbox-group v-model="group.preset" @change="onPresetChange">
                    <a-row>
                      <a-col :span="8">
                        <a-checkbox value="all"> All Customers </a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="chinese"> Chinese Customers </a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="english"> English Customers </a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="new1month"> New Customers (1 months)</a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="new2month"> New Customers (2 months) </a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="new3month"> New Customers (3 months) </a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="new6month"> New Customers (6 months) </a-checkbox>
                      </a-col>
                      <a-col :span="8">
                        <a-checkbox value="new12month"> New Customers (1 year) </a-checkbox>
                      </a-col>
                    </a-row>
                  </a-checkbox-group>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CustomerSelectorTable } from '@/components/reno/tables'
import { Filters } from '@/components/reno/filters'
import router from '@/router'

export default {
  components: {
    CustomerSelectorTable,
    Filters,
  },
  data() {
    return {
      size: 'large',
      group: null,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px',
      },
      selectedKeys: [],
    }
  },
  methods: {
    onFilter(_filteredRecipients) {
      const filteredRecipients = JSON.parse(JSON.stringify(_filteredRecipients))
      this.onSelectionChange(filteredRecipients)
    },
    onPresetChange(presets) {
      if (presets) {
        if (presets.includes('all')) this.group.preset = ['all']
      }
    },
    onUpdateGroup() {
      if (this.group) {
        if (this.group.name && this.group.description) {
          this.$store.dispatch('marketing/updateRecipientGroup', this.group)
          this.$router.push({ name: 'recipients' })
        } else {
          this.$message.error('Please fill all informations')
        }
      }
    },
    onSelectionChange(list) {
      this.selectedKeys = list
      this.group.recipients = list
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.group = await this.$store.dispatch('marketing/fetchRecipientGroup', this.$route.params.id)
      if (this.group && this.group.recipients) {
        this.onSelectionChange(this.group.recipients)
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
